<style type="less" scoped>
    @import url('./css.less');
</style>
<template>
    <div class="container">
        <BusinessEchartBmap v-on:map-load="mapLoad" v-bind="$props" ref='map'>
        </BusinessEchartBmap>
    </div>
</template>

<script>
    import BusinessEchartBmap from './../../map/common/businessEchartBmap/index';
    import mapPropsMinxin from './default-props-value';
    import inMap from './../../../lib/inmap';
    const axios = require('axios');
    import {
        colToRow,
        rowsToGeo
    } from './../../../lib/utils';
    export default {
        name: '',
        mixins: [mapPropsMinxin],
        components: {
            BusinessEchartBmap
        },
        data() {
            const cacheData = {
                heatOverlay: null
            };
            return {
                getCacheData() {
                    return cacheData;
                }
            }
        },
        watch: {
            api() {
                api && this.ajaxData();
            },
            gradient() {
                this.setStyleOption();
            },
            radius() {
                this.setStyleOption();
            },
            maxValue() {
                this.setStyleOption();
            },
            opacity() {
                this.setStyleOption();
            }
        },
        computed: {},
        methods: {
            _initMap() {
                const mapComponent = this.$refs.map.getMapComponent();
                const heatOverlay = new inMap.HeatOverlay(this.getHeatOption());
                mapComponent.addInMapOverlay(heatOverlay);
                this.getCacheData().heatOverlay = heatOverlay;
            },
            getHeatOption() {
                const maxValue = this.maxValue == "" ? null : parseInt(this.maxValue);
                if (this.gradient == null) {
                    console.error('map gradient 格式不对');
                }
                const option = {
                    gradient: this.gradient,
                    style: {
                        radius: this.radius, // 半径
                        maxValue: maxValue,
                        maxOpacity: this.opacity
                    },
                    animation: {
                        type: 'time',
                        stepsRange: {
                            start: 0,
                            end: 100
                        },
                        trails: 10,
                        duration: 1,
                    },
                };
                return option;
            },
            setStyleOption() {
                const heatOverlay = this.getCacheData().heatOverlay;
                if (heatOverlay) {
                    heatOverlay.setOptionStyle(this.getHeatOption());
                }

            },
            ajaxData() {
                axios.get(this.api)
                    .then((response) => {
                        const data = response.data;
                        const rows = colToRow(data);
                        const geoData = rowsToGeo(rows);
                        this.getCacheData().heatOverlay.setData(geoData);
                    });
            },
            mapLoad() {
                this._initMap();
                this.ajaxData();
            },
            resize() {
                this.$refs.map.resize();
            }
        },
        mounted() {

        }
    }
</script>